// extracted by mini-css-extract-plugin
export default {"container":"barChartSimple_container__E+Kjs"};